import React, { useMemo } from "react";
import commonStyles from "./CommonStyles.module.scss";
import ReferralIcon from "assets/icons/referral.svg?react";
import { ReferralParticipantResponse } from "@switcherstudio/switcher-api-client";
import { useTranslation } from "react-i18next";
import { Widget } from "./Widget";
import { useReferralLink } from "hooks/useReferralLink";

export const ReferralParticipantWidget: React.FC<
    ReferralParticipantResponse
> = () => {
    const { t } = useTranslation("widgets");
    const { shareLink, loading, copyLink } = useReferralLink();

    const widgetParagraph = useMemo(
        () =>
            shareLink === null
                ? t("widgets:referral-paragraph-error")
                : t("dynamic-action:referral:subheader"),
        [shareLink, t]
    );

    if (loading) return;

    return (
        <Widget
            loading={loading}
            icon={<ReferralIcon style={{ transform: "scale(1.4)" }} />}
            title={t("widgets:referral-header")}
            button={
                <button
                    className="btn btn-outline-secondary"
                    onClick={copyLink}
                >
                    {t("widgets:copy-link").toUpperCase()}
                </button>
            }
        >
            <p className={commonStyles["paragraph"]}>{widgetParagraph}</p>
        </Widget>
    );
};
